import produce from 'immer'
import { createAsyncObject } from '@jarvis.oddle/core/tools/redux/action'
import { updateForAsyncRequest, updateForAsyncSuccess, updateForAsyncFailure } from '@jarvis.oddle/core/tools/redux/reducer'
import * as C from './constants'

// TODO: Move billingAddressForm, checkoutForm to component state
export const initialState = {
  meta: createAsyncObject({}),
  paymentMethods: createAsyncObject([]),
  paymentToken: createAsyncObject(null),
  checkoutResults: createAsyncObject({}),
  vouchers: createAsyncObject([]),
  selectedVoucher: createAsyncObject({}),
  checkoutAddressInfo: {},
  selectedSavedCreditCard: createAsyncObject({})
}

export const reducers = (state = initialState, action) => produce(state, draftState => {
  switch (action.type) {
    case C.GET_CHECKOUT_META_REQUEST: updateForAsyncRequest(draftState.meta); break
    case C.GET_CHECKOUT_META_SUCCESS: updateForAsyncSuccess(action.payload.meta)(draftState.meta); break
    case C.GET_CHECKOUT_META_FAILURE: updateForAsyncFailure(action)(draftState.meta); break
    case C.GET_CHECKOUT_PAYMENT_METHODS_REQUEST: updateForAsyncRequest(draftState.paymentMethods); break
    case C.GET_CHECKOUT_PAYMENT_METHODS_SUCCESS: updateForAsyncSuccess(action.payload.paymentOptions)(draftState.paymentMethods); break
    case C.GET_CHECKOUT_PAYMENT_METHODS_FAILURE: updateForAsyncFailure(action)(draftState.paymentMethods); break
    case C.GET_PAYMENT_TOKEN_REQUEST: updateForAsyncRequest(draftState.paymentToken); break
    case C.GET_PAYMENT_TOKEN_SUCCESS: updateForAsyncSuccess(action.payload.token)(draftState.paymentToken); break
    case C.GET_PAYMENT_TOKEN_FAILURE: updateForAsyncFailure(action)(draftState.paymentToken); break
    case C.CHECKOUT_REQUEST: updateForAsyncRequest(draftState.checkoutResults); break
    case C.CHECKOUT_SUCCESS: updateForAsyncSuccess(action.payload.result)(draftState.checkoutResults); break
    case C.CHECKOUT_FAILURE: updateForAsyncFailure(action)(draftState.checkoutResults); break
    case C.UPDATE_DELIVERY_DETAILS_SUCCESS: updateForAsyncSuccess({ ...state.meta.data, storeOrder: action.payload })(draftState.meta); break /* state.meta.data.storeOrder */
    case C.GET_LIST_OF_VOUCHERS_REQUEST: updateForAsyncRequest(draftState.vouchers); break
    case C.GET_LIST_OF_VOUCHERS_SUCCESS: updateForAsyncSuccess(action.payload)(draftState.vouchers); break
    case C.GET_LIST_OF_VOUCHERS_FAILURE: updateForAsyncFailure(action)(draftState.vouchers); break
    case C.REMOVE_SELECTED_VOUCHER: draftState.selectedVoucher = createAsyncObject({}); break
    case C.SET_SELECTED_VOUCHER: draftState.selectedVoucher = createAsyncObject(action.payload.selectedVoucher); break
    case C.VALIDATE_VOUCHER_REQUEST: updateForAsyncRequest(draftState.selectedVoucher); break
    case C.VALIDATE_VOUCHER_SUCCESS: updateForAsyncSuccess(() => {
      const selectedVoucherInfo = (draftState.vouchers.data || []).find((voucher) => voucher.code === action.payload.code)

      draftState.selectedVoucher.data = {
        ...(action.payload || {}),
        ...(selectedVoucherInfo || {})
      }
    })(draftState.selectedVoucher)
      break
    case C.VALIDATE_VOUCHER_FAILURE: updateForAsyncFailure(action)(draftState.selectedVoucher); break
    case C.STORE_CHECKOUT_ADDRESS_INFO: draftState.checkoutAddressInfo = action.payload
      break
    case C.SELECTED_SAVED_CREDIT_CARD: updateForAsyncSuccess(action.payload)(draftState.selectedSavedCreditCard)
      break
    case C.UPDATE_CHECKOUT_META_REQUEST: updateForAsyncRequest(draftState.meta); break
    case C.UPDATE_DELIVERY_DETAILS_FAILURE: updateForAsyncFailure(action)(draftState.meta); break
    case C.UPDATE_CHECKOUT_META_SUCCESS: updateForAsyncSuccess(() => {
      const result = {
        ...draftState.meta.data,
        storeOrder: action.payload 
      }
      draftState.meta.data = result
    })(draftState.meta) 
      break
  }
})
